module.exports = __webpack_public_path__ + "img/left_1.d611237a.svg";